import queryString from "query-string";

const filterId = function (state, props) {
  const values = queryString.parse(props.location.search);
  return values.filterId;
};

function site(state, props) {
  if (state.site) {
    return state.site;
  }
  const values = queryString.parse(props.location.search);
  return values.site;
}

function cases(state, props) {
  const id = filterId(state, props);
  const { cases } = state.casesByFilter[id] || { cases: [] };
  return cases;
}

export default {
  filterId,
  site,
  cases,
};
